import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core'
import { CpmService } from '../../service/cpm.service'
import { FormControl, FormGroup } from '@angular/forms'
import { Router } from '@angular/router'
import { ActivatedRoute } from '@angular/router'
import { PdfChart } from '../../shared/pdfChart'

@Component({
  selector: 'app-watch-list',
  templateUrl: './watch-list.component.html',
  styleUrls: ['./watch-list.component.scss']
})
export class WatchListComponent implements OnInit, AfterViewInit {
  getDataWatchlist = []
  marketWlTable
  tradingDate
  endYear
  form: FormGroup
  currentItem = 'sign'
  marketWlticker
  marketWlSector
  marketWlMarket
  pdfChart: PdfChart = new PdfChart()
  marketWlDate
  getPrint
  marketWlType
  dataWatchList = []
  nameTicker = []
  dataTable = []
  listByCompany = []
  getDataForExcel = []
  dataDisc = []
  radios = [
    { value: 'sign', des: 'Sort by sign & trading alert' },
    { value: 'comp', des: 'Sort by company' }
  ]

  constructor(
    private cpmService: CpmService,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.getLastTradingDate().then(endYear =>
      this.loadDataFromGetLastTradingDate(endYear)
    )

    const { currentItem } = this.activatedRoute.snapshot.params
    const { pdf, print } = this.activatedRoute.snapshot.data
    this.pdfChart.setPdf(pdf)
    this.getPrint = print
    currentItem === undefined
      ? (this.currentItem = 'sign')
      : (this.currentItem = currentItem)

    this.form = new FormGroup({
      radioValue: new FormControl(this.currentItem)
    })

    this.onChangeData()
  }

  onChangeData() {
    this.dataWatchList = []
    this.cpmService
      .getMarketLevelWatchList(this.form.get('radioValue').value)
      .subscribe(obj => {
        obj.map(value => {
          this.dataWatchList.push(value)
        })

        this.marketWlticker = obj.map(mTicker => mTicker.ticker)
        this.marketWlSector = obj.map(mSector => mSector.sectorNameEng)
        this.marketWlType = obj.map(mType => mType.type)
        this.marketWlDate = obj.map(mDate => mDate.postdate)
        this.marketWlMarket = obj.map(mMarket => mMarket.market)
        this.marketWlType = this.marketWlType.reduce(function (a, b) {
          if (a.indexOf(b) < 0) {
            a.push(b)
          }
          return a
        }, [])

        this.marketWlticker = this.marketWlticker.reduce(function (a, b) {
          if (a.indexOf(b) < 0) {
            a.push(b)
          }
          return a
        }, [])

        this.marketWlSector = this.marketWlSector.reduce(function (a, b) {
          if (a.indexOf(b) < 0) {
            a.push(b)
          }
          return a
        }, [])
        this.marketWlMarket = this.marketWlMarket.reduce(function (a, b) {
          if (a.indexOf(b) < 0) {
            a.push(b)
          }
          return a
        }, [])

        this.marketWlTable = []
        this.nameTicker = []
        this.dataTable = []

        this.marketWlType.map(type => {
          switch (type) {
            case 'SP':
              this.nameTicker.push(
                'SP อยู่ระหว่างการห้ามซื้อหรือขายเป็นการชั่วคราว (Suspension)'
              )
              this.dataTable.push(
                this.dataWatchList.filter(res => res.type === type)
              )
              break
            case 'H':
              this.nameTicker.push(
                'H อยู่ระหว่างการห้ามซื้อหรือขายเป็นการชั่วคราว (ภายใน 1 Session)'
              )
              this.dataTable.push(
                this.dataWatchList.filter(res => res.type === type)
              )
              break
            case 'C':
              this.nameTicker.push('C Caution')
              this.dataTable.push(
                this.dataWatchList.filter(res => res.type === type)
              )
              break
            case '3':
              this.nameTicker.push('Cash balance level 3 (หลักทรัพย์ที่ห้าม Net settlement)')
              this.dataTable.push(
                this.dataWatchList.filter(res => res.type === type)
              )
              break
            case '2':
              this.nameTicker.push(
                'Cash balance level 2 (หลักทรัพย์ที่ห้ามคำนวณวงเงินซื้อขาย)'
              )
              this.dataTable.push(
                this.dataWatchList.filter(res => res.type === type)
              )
              break
            case '1':
              this.nameTicker.push(
                'Cash balance level 1 (หลักทรัพย์ที่ต้องวางเงินสดเต็มจำนวน)'
              )
              this.dataTable.push(
                this.dataWatchList.filter(res => res.type === type)
              )
              break
            case 'NP':
              this.nameTicker.push(
                'NP อยู่ระหว่างรอข้อมูลจากบริษัท (Notice pending)'
              )
              this.dataTable.push(
                this.dataWatchList.filter(res => res.type === type)
              )
              break
            case 'NC':
              this.nameTicker.push('NC (Non compliance)')
              this.dataTable.push(
                this.dataWatchList.filter(res => res.type === type)
              )
              break
            case 'NPG':
              this.nameTicker.push('NPG (Non performing group)')
              this.dataTable.push(
                this.dataWatchList.filter(res => res.type === type)
              )
              break
          }
        })
        this.listByCompany = []
        this.marketWlticker.map(tic => {
          let list = []
          this.marketWlSector.map(sec => {
            this.marketWlMarket.map(mak => {
              const filters = {
                ticker: [tic],
                sectorNameEng: [sec],
                market: [mak]
              }
              list = []
              list = this.multiFilter(this.dataWatchList, filters)
              if (list.length !== 0) {
                const detail = list.map(li => {
                  const dis = {
                    type: li.type,
                    ticker: li.ticker,
                    postdate: li.postdate,
                    disc: this.getDisc(li.type)
                  }
                  return dis
                })

                const name = tic + ' - ' + mak + ' - ' + sec
                const table = {
                  name: name,
                  list: detail
                }
                this.listByCompany.push(table)
              }
            })
          })
        })
      })
  }
  async getLastTradingDate(): Promise<number> {
    const date = await this.cpmService.getLastTradingDate()
    const lastTrading = new Date(date.lastTradingDate.toString())
    const options = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    }
    let dateTime
    dateTime = lastTrading.toLocaleDateString('en-EN', options)
    this.tradingDate = dateTime
    return lastTrading.getFullYear()
  }
  loadDataFromGetLastTradingDate(endYear) {
    this.endYear = endYear
    const startYear = this.endYear - 4
  }

  multiFilter(array, filters) {
    const filterKeys = Object.keys(filters)
    // filters all elements passing the criteria
    return array.filter(item => {
      // dynamically validate all filter criteria
      // tslint:disable-next-line:no-bitwise
      return filterKeys.every(key => !!~filters[key].indexOf(item[key]))
    })
  }

  getDisc(name) {
    switch (name) {
      case 'SP':
        return 'SP อยู่ระหว่างการห้ามซื้อหรือขายเป็นการชั่วคราว (Suspension)'
      case 'H':
        return 'H อยู่ระหว่างการห้ามซื้อหรือขายเป็นการชั่วคราว (ภายใน 1 Session)'
      case 'C':
        return 'C Caution'
      case '3':
        return 'Cash balance level 3 (หลักทรัพย์ที่ห้าม Net settlement)'
      case '2':
        return 'Cash balance level 2 (หลักทรัพย์ที่ห้ามคำนวณวงเงินซื้อขาย)'
      case '1':
        return 'Cash balance level 1 (หลักทรัพย์ที่ต้องวางเงินสดเต็มจำนวน)'
      case 'NP':
        return 'NP อยู่ระหว่างรอข้อมูลจากบริษัท (Notice pending)'
      case 'NC':
        return 'NC (Non compliance)'
      case 'NPG':
        return 'NPG (Non performing group)'
    }
  }

  ngAfterViewInit() {
    if (this.getPrint) {
      window.setTimeout('window.print()', 2000);
    }
  }

}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/market-level/watch-list/watch-list.component.ts